import { action, makeObservable, observable } from 'mobx';
/**
 * Store for fetching public data of packets + requesting
 * access to the packet
 */
export default class RequestPacketAccessStore {
  @observable packets = {};

  constructor(parent) {
    makeObservable(this);
    this.parent = parent;
    this.api = this.parent.api.requestPacketAccess;
  }

  @action.bound
  async getPacketData(uuid) {
    if (this.packets[uuid]) {
      return;
    }
    const { data } = await this.api.getPacketData(uuid);
    this.packets[uuid] = data;
  }

  saveAccessRequest(uuid, saveAccessRequest) {
    return this.api.saveAccessRequest(uuid, saveAccessRequest);
  }
}
